import { numbers } from '@/utils';

export default {
	analytics: (state) => state.analytics,
	topCampaigns: (state) => state.topCampaigns,
	impressions(state, getters) {
		return numbers.withCommas(getters.analytics.impressions, 0);
	},
	conversions(getters) {
		return numbers.withCommas(getters.analytics.conversions, 0);
	},
	rate(getters) {
		return numbers.withCommas(getters.analytics.rate, 0);
	},
	dateRange: (state) => state.dateRange,
};
